import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AlertService } from '@core/services/alert.service';
import { SidebarService } from '@core/services/sidebar.service';
import { normalizeUrl } from '@core/utils/util';

const ALWAYS_ALLOWED_PATHS = new Set(['/my-account', '/sale']);

function resolveMenuAccess(url: string) {
  const router = inject(Router);
  const alertService = inject(AlertService);
  const sidebarService = inject(SidebarService);
  const currentPath = normalizeUrl(url);

  if (ALWAYS_ALLOWED_PATHS.has(currentPath) || sidebarService.hasAccessToPath(currentPath)) {
    return true;
  }

  const fallbackPath = sidebarService.getFirstAccessiblePath() ?? '/my-account';

  if (currentPath !== '/' && currentPath !== fallbackPath) {
    alertService.open({
      type: 'warning',
      message: 'No tienes acceso a esta sección con tu rol actual.',
    });
  }

  return router.createUrlTree([fallbackPath], {
    queryParams: currentPath !== '/' ? { from: currentPath } : undefined,
  });
}

export const menuAccessChildGuard: CanActivateChildFn = (_childRoute, state) =>
  resolveMenuAccess(state.url);
